export const defaultFilters = {
  query: '',
  store: false,
  terminal: false,
  pickup: false,
  post: false,
  fitting: false,
  returns: false,
  cardPay: false,
  dayAndNight: false,
  withoutPrepay: false,
  withoutQrCode: false,
};

export const PICKUP_FILTERS = {
  store: {
    value: 'store',
    label: 'Магазин',
  },
  terminal: {
    value: 'terminal',
    label: 'Постамат',
  },
  pickup: {
    value: 'pickup',
    label: 'ПВЗ',
  },
  fitting: {
    value: 'fitting',
    label: 'Есть примерка',
  },
  returns: {
    value: 'returns',
    label: 'Есть возврат',
  },
  cardPay: {
    value: 'cardPay',
    label: 'Оплата картой',
  },
  dayAndNight: {
    value: 'dayAndNight',
    label: 'Круглосуточно',
  },
  withoutPrepay: {
    value: 'withoutPrepay',
    label: 'Без предоплаты',
  },
  withoutQrCode: {
    value: 'withoutQrCode',
    label: 'Без QR-кода',
  },
  availableToday: {
    value: 'availableToday',
    label: 'В наличии сегодня',
  },
};
